module.exports = __webpack_public_path__ + "static/img/spacestudio-noir.df659f7.png";